import React from 'react';
import StatusBadge from './StatusBadge';
import getTaskIcon from './ClaimTaskIcons';
const AYMING_BLUE = '#00aeef';
const AYMING_BLUE_LIGHT = '#E6F1FB';
const TaskStep = _ref => {
  let {
    task,
    isActive,
    isSelected,
    onClick,
    label
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1,
      position: 'relative',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      width: '44px',
      height: '44px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '44px',
      height: '44px',
      borderRadius: '10px',
      background: isActive ? AYMING_BLUE : AYMING_BLUE_LIGHT,
      border: isSelected && !isActive ? "2px solid ".concat(AYMING_BLUE) : 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: isActive ? '0 0 0 3px #B5D4F4' : 'none',
      transition: 'all 0.15s ease'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '22px',
      color: isActive ? '#fff' : AYMING_BLUE
    }
  }, getTaskIcon(task.category_title))), /*#__PURE__*/React.createElement(StatusBadge, {
    status: task.status,
    categoryTitle: task.category_title
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '11px',
      color: isActive || isSelected ? AYMING_BLUE : '#6B7280',
      fontWeight: isActive || isSelected ? 500 : 400,
      textAlign: 'center',
      maxWidth: '72px',
      lineHeight: 1.3
    }
  }, label));
};
export default TaskStep;